"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = require("../../elements/link/Link");
var _classnames = _interopRequireDefault(require("classnames"));
var _caretDown = require("../../assets/icons/caret-down.svg");
var _breadcrumbsModule = _interopRequireDefault(require("./breadcrumbs.module.scss"));
var Breadcrumbs = function Breadcrumbs(_ref) {
  var items = _ref.items,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)(_breadcrumbsModule.default['breadcrumbs__list'], className)
  }, items.map(function (_ref2, index) {
    var name = _ref2.name,
      href = _ref2.href;
    return /*#__PURE__*/_react.default.createElement("li", {
      className: _breadcrumbsModule.default['breadcrumbs__item'],
      key: "".concat(name, "-").concat(index)
    }, href ? /*#__PURE__*/_react.default.createElement(_Link.Link, {
      className: _breadcrumbsModule.default['breadcrumbs__link'],
      href: href
    }, name, /*#__PURE__*/_react.default.createElement(_caretDown.ReactComponent, {
      className: _breadcrumbsModule.default['breadcrumbs__item--icon']
    })) : /*#__PURE__*/_react.default.createElement("span", {
      className: _breadcrumbsModule.default['breadcrumbs__element']
    }, name, /*#__PURE__*/_react.default.createElement(_caretDown.ReactComponent, {
      className: _breadcrumbsModule.default['breadcrumbs__item--icon']
    })));
  }));
};
exports.Breadcrumbs = Breadcrumbs;